module.exports = __webpack_public_path__ + "static/media/benz-18.5b9c6e4b.jpg";